// זיהוי גולשים שהגיעו ממנועי AI (ChatGPT, Perplexity, Gemini וכו').
// המקור נשמר לכל הסשן, כדי שאפשר יהיה לשייך אליו לידים ולחיצות וואטסאפ ב-GA4.

const AI_SOURCES = [
  { name: "chatgpt", match: ["chatgpt.com", "chat.openai.com", "openai.com"] },
  { name: "perplexity", match: ["perplexity.ai"] },
  { name: "gemini", match: ["gemini.google.com", "bard.google.com"] },
  { name: "copilot", match: ["copilot.microsoft.com", "copilot.cloud.microsoft"] },
  { name: "claude", match: ["claude.ai"] },
  { name: "grok", match: ["grok.com", "x.ai"] },
  { name: "meta_ai", match: ["meta.ai"] },
  { name: "deepseek", match: ["deepseek.com"] },
  { name: "you", match: ["you.com"] },
];

const STORAGE_KEY = "qt_ai_source";

function matchSource(value) {
  if (!value) return null;
  const v = value.toLowerCase();
  const found = AI_SOURCES.find(
    (s) => v === s.name || s.match.some((m) => v === m || v.endsWith("." + m))
  );
  return found ? found.name : null;
}

// ChatGPT מוסיף בדרך כלל utm_source=chatgpt.com; אחרים מזוהים לפי ה-referrer.
function detectAiSource() {
  try {
    const utm = new URLSearchParams(window.location.search).get("utm_source");
    const fromUtm = matchSource(utm);
    if (fromUtm) return fromUtm;
    if (document.referrer) return matchSource(new URL(document.referrer).hostname);
  } catch (e) {
    // referrer לא תקין — מתעלמים
  }
  return null;
}

// נקרא פעם אחת בטעינת האתר. שולח אירוע ai_referral רק בכניסה הראשונה של הסשן.
export function initAiReferral() {
  let stored = null;
  try {
    stored = sessionStorage.getItem(STORAGE_KEY);
  } catch (e) {}
  if (stored) return;

  const source = detectAiSource();
  if (!source) return;

  try {
    sessionStorage.setItem(STORAGE_KEY, source);
  } catch (e) {}

  if (window.gtag) {
    window.gtag("event", "ai_referral", {
      ai_source: source,
      landing_page: window.location.pathname,
    });
  }
}

// מחזיר את מקור ה-AI של הסשן, או "none" — להוספה כפרמטר לאירועי המרה.
export function getAiSource() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || "none";
  } catch (e) {
    return "none";
  }
}
